<template>
	<div class="auth-loader-wrapper">
		<div class="auth-loader-inner">
			<CloudLoader animate />
			<p>Authenticating...</p>
			<p>Please sit tight.</p>
		</div>
	</div>
</template>

<script>
import { CloudLoader } from '@/components/common'

export default {
	components: { CloudLoader },
}
</script>

<style scoped>
.auth-loader-wrapper {
	background-color: #d1d2d4;
	height: 100vh;
	width: 100vw;
	padding: 25px;
}

.auth-loader-inner {
	background-color: #ffffff;
	height: 100%;
	width: 100%;
	border-radius: 8px;
	text-align: center;
	padding-top: 35%;
}
.auth-loader-inner p:first-of-type {
	font-family: Avenir-Medium;
	font-size: 18px;
	height: 18px;
}
.auth-loader-inner p:last-of-type {
	font-family: Avenir-Medium;
	font-size: 12px;
}
</style>
